import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ShoppingBag({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ShoppingBag</title>
      <path
        d="M5 9C5 7.89543 5.89543 7 7 7H17C18.1046 7 19 7.89543 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 10C14.25 10.4142 14.5858 10.75 15 10.75C15.4142 10.75 15.75 10.4142 15.75 10H14.25ZM8.25 10C8.25 10.4142 8.58579 10.75 9 10.75C9.41421 10.75 9.75 10.4142 9.75 10H8.25ZM14.25 6V10H15.75V6H14.25ZM9.75 10V6H8.25V10H9.75ZM12 3.75C13.2426 3.75 14.25 4.75736 14.25 6H15.75C15.75 3.92893 14.0711 2.25 12 2.25V3.75ZM12 2.25C9.92893 2.25 8.25 3.92893 8.25 6H9.75C9.75 4.75736 10.7574 3.75 12 3.75V2.25Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
